export default __webpack_public_path__ + "resumen2.jpg";